import {Axios} from '@asocial/fe-utils'
import {AxiosResponse} from 'axios'
import {SettingsKeys} from 'shared/types'

type NotificationSettings = {
  idUser?: string,
  messages: boolean,
  likes: boolean,
  visits: boolean,
  favorites: boolean,
  marketing: boolean
}

export const SetSetting = (name: SettingsKeys, value: any): Promise<null> =>
  Axios.put(`settings/kv/${name}`, {value})

export const GetSettingsNotifications = (): Promise<AxiosResponse<NotificationSettings>> =>
  Axios.get('settings/notifications')

export const UpdateSettingsNotifications = (params: NotificationSettings): Promise<AxiosResponse<NotificationSettings>> =>
  Axios.put('settings/notifications', {...params})
